module.exports = __webpack_public_path__ + "img/home.e3404120.png";